import { render } from "./CookieDisclosure.vue?vue&type=template&id=635666ae&scoped=true"
import script from "./CookieDisclosure.vue?vue&type=script&lang=js"
export * from "./CookieDisclosure.vue?vue&type=script&lang=js"

import "./CookieDisclosure.vue?vue&type=style&index=0&id=635666ae&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-635666ae"]])

export default __exports__